module.exports = __webpack_public_path__ + "static/media/Panda Guy.29e74753.jpg";